// extracted by mini-css-extract-plugin
export default {"PrimaryButton":"PrimaryBtn_PrimaryButton__oiXkQ","Disabled":"PrimaryBtn_Disabled__y4BRE"};